import { useEffect, useRef, useState } from 'react'

const MAX_POINTS = 12

/** Acumula en memoria (no persistido) los últimos valores vistos de un número
 * que hoy solo llega como snapshot actual (stats/overview no exponen series
 * de tiempo) — alcanza para una mini-tendencia real (no inventada) mientras
 * la pestaña sigue abierta y sigue haciendo polling, sin agregar un endpoint
 * nuevo solo para esto. */
export function useTrend(value: number | undefined): number[] {
  const [history, setHistory] = useState<number[]>([])
  const lastValue = useRef<number | undefined>(undefined)

  useEffect(() => {
    if (value === undefined || value === lastValue.current) return
    lastValue.current = value
    setHistory((prev) => [...prev, value].slice(-MAX_POINTS))
  }, [value])

  return history
}
